import { useEffect, useState } from 'react'
import { handleFetchText } from '../../services/MemoriesAPI/memoriesAPI'

export default function useProcessedStories(stories) {
  const [processedStories, setProcessedStories] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const processStories = async () => {
      if (!stories?.length) {
        setLoading(false)
        return
      }
      setLoading(true)
      setError(null)
      try {
        const processed = await Promise.all(
          stories.map(async (story) => {
            let fullText
            try {
              fullText = await handleFetchText(story.url, true)
            } catch (err) {
              console.error('Failed to fetch text for story:', story.id, err)

              throw err
            }
            return { ...story, fullText }
          })
        )
        setProcessedStories(processed)
      } catch (err) {
        setError(err)
        setProcessedStories([])
      } finally {
        setLoading(false)
      }
    }
    processStories()
  }, [stories])

  return { processedStories, loading, error }
}
